/**
 *
 * @param secondsValue The number of seconds to be converted to hours, minutes and seconds format
 * @returns An object containing the hours, minutes and seconds represented by the passed seconds
 */
const convertSeconds = (secondsValue) => {
    const SECONDS_PER_HOUR = 3600;
    const SECONDS_PER_MINUTE = 60;
    const SECONDS_PER_DAY = SECONDS_PER_HOUR * 24;
    const days = Math.floor(secondsValue / SECONDS_PER_DAY);
    const hours = Math.floor((secondsValue - days * SECONDS_PER_DAY) / SECONDS_PER_HOUR);
    const minutes = Math.floor((secondsValue - days * SECONDS_PER_DAY - hours * SECONDS_PER_HOUR) /
        SECONDS_PER_MINUTE);
    const seconds = Math.floor(secondsValue -
        days * SECONDS_PER_DAY -
        hours * SECONDS_PER_HOUR -
        minutes * SECONDS_PER_MINUTE);
    return {
        days,
        hours,
        seconds,
        minutes,
    };
};
/**
 *
 * @param date1 The first date instance
 * @param date2 The second date instance, if this is not provided, the passed date is compared against `new Date()` instance
 * @returns the difference between two dates in seconds (integer)
 */
const getDateDifferenceInSeconds = (date1, date2 = new Date()) => {
    return Math.ceil(+date1 / 10 ** 3 - +date2 / 10 ** 3);
};

/**
 * Generated bundle index. Do not edit.
 */

export { convertSeconds, getDateDifferenceInSeconds };
